import { Outlet } from "react-router-dom";
import { Layout as DashboardLayout } from "src/layouts/dashboard";
import { Layout as MarketingLayout } from "src/layouts/marketing";
import HomePage from "src/pages";
import Error401Page from "src/pages/401";
import Error404Page from "src/pages/404";
import Error500Page from "src/pages/500";
import LegalPage from "src/pages/legal";
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";

export const routes = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "terms",
        element: <LegalPage type="terms" />,
      },
      {
        path: "privacy",
        element: <LegalPage type="privacy" />,
      },
    ],
  },
  ...authRoutes,
  ...dashboardRoutes,
  {
    path: "401",
    element: <Error401Page />,
  },
  {
    path: "404",
    element: <DashboardLayout rememberRoute={false} forceMenu><Error404Page /></DashboardLayout>,
  },
  {
    path: "500",
    element: <Error500Page />,
  },
  {
    path: "*",
    element: <DashboardLayout rememberRoute={false} forceMenu><Error404Page /></DashboardLayout>,
  },
];
